"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var _migrating = _interopRequireDefault(require("element-ui/lib/mixins/migrating"));

var _popup = _interopRequireDefault(require("element-ui/lib/utils/popup"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "el-dialog__wrapper",
    attrs: {},
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.handleWrapperClick($event);
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "el-dialog",
    "class": [{
      'is-fullscreen': _vm.fullscreen,
      'el-dialog--center': _vm.center
    }, _vm.customClass],
    style: _vm._px2rem(_vm.style, 24, []),
    attrs: {}
  }, [_vm.showHeader ? _c('div', {
    staticClass: "el-dialog__header",
    attrs: {}
  }, [_vm._t("title", [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.title))])], {}), _vm._v(" "), _vm.showClose ? _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close",
    attrs: {}
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.rendered ? _c('div', {
    staticClass: "el-dialog__body",
    attrs: {}
  }, [_vm._t("default", null, {})], 2) : _vm._e(), _vm._v(" "), _vm.$slots.footer ? _c('div', {
    staticClass: "el-dialog__footer",
    attrs: {}
  }, [_vm._t("footer", null, {})], 2) : _vm._e()])])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElDialog',
  mixins: [_popup["default"], _emitter["default"], _migrating["default"]],
  props: {
    title: {
      type: String,
      "default": ''
    },
    modal: {
      type: Boolean,
      "default": true
    },
    modalAppendToBody: {
      type: Boolean,
      "default": true
    },
    appendToBody: {
      type: Boolean,
      "default": false
    },
    lockScroll: {
      type: Boolean,
      "default": true
    },
    closeOnClickModal: {
      type: Boolean,
      "default": true
    },
    closeOnPressEscape: {
      type: Boolean,
      "default": true
    },
    showClose: {
      type: Boolean,
      "default": true
    },
    // 扩展 新增头部显示开关
    showHeader: {
      type: Boolean,
      "default": true
    },
    width: String,
    fullscreen: Boolean,
    customClass: {
      type: String,
      "default": ''
    },
    top: {
      type: String,
      "default": '15vh'
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(function () {
          _this.$refs.dialog.scrollTop = 0;
        });

        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
      }
    }
  },
  computed: {
    style: function style() {
      var style = {};

      if (!this.fullscreen) {
        style.marginTop = this.top;

        if (this.width) {
          style.width = this.width;
        }
      }

      return style;
    }
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          size: 'size is removed.'
        }
      };
    },
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();

      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
exports["default"] = _default;